<template>
    <div class="lightbox-settings">

        <!-- settings group: TRIGGER -->
        <div class="settings-group-title">
            <h6>lightbox trigger</h6>
        </div>

        <div class="settings-group">
            
            <!-- domain url -->
            <div class="setting">
                <b-form-group>

                    <label for="button-text-input">Your domain url: <span v-b-tooltip.hover.top title="Grab your url from the browser address bar"><i class="far fa-question-circle"></i></span></label>

                    <b-form-input id="button-text-input" type="url" v-model="settingsFromWeebly.settings.urlDomain" size="sm" />

                </b-form-group>
            </div>

            <!-- Trigger link -->
            <div class="setting">
                <b-form-group>

                    <label>Trigger link to use: <span v-b-tooltip.hover.top title="Copy this string to add as a link to (a) Weebly element(s)"><i class="far fa-question-circle"></i></span></label>

                    <div class="trigger-link-to-copy">{{settingsFromWeebly.settings.urlDomain || 'url_not_found'}}?data-popup=bundle-lightbox-{{globalSettings.elementIdWeebly || 'id_not_found'}}</div>

                </b-form-group>
            </div>

        </div>

        <!-- settings group: STYLES LIGHTBOX -->
        <div class="settings-group-title">
            <h6>lightbox area</h6>
        </div>
        <div class="settings-group">
            <!-- lightbox width -->
            <div class="setting">
                <b-form-group>

                    <label for="lightbox-width-input">Lightbox width:</label>
                    
                    <b-input-group append="px" size="sm">
                        <b-form-input id="lightbox-width-input" type="number" v-model="settingsFromWeebly.settings.lightBoxWidth" min="50" />
                    </b-input-group>

                </b-form-group>
            </div>
            <!-- content background -->
            <div class="setting">
                <Mycolorpicker elementRef="bodyBackground" theColorPicker="allpickers" colorPickerName="Body background:" />
            </div>

            <div class="setting">
                <b-form-checkbox @change="settingsFromWeebly.settings.useShadow = !settingsFromWeebly.settings.useShadow" switch v-model="settingsFromWeebly.settings.useShadow" name="use-shadow-lighbox">
                    Use shadow
                </b-form-checkbox>
            </div>

            <div class="settings-group">
                <!-- close icon color -->
                <div class="setting">
                    <Mycolorpicker elementRef="closeIconColor" theColorPicker="allpickers" colorPickerName="Close icon color:" />
                </div>
            </div>

        </div>

        <!-- settings group: TITLE SETTINGS -->
        <div class="settings-group-title">
            <h6>title area</h6>
        </div>
        <div class="settings-group">
            <!-- use title -->
            
            <label style="margin-bottom: 15px;">Fixed title: <span v-b-tooltip.hover.top title="This title will always be visible when lightboxes become long scrolling elements"><i class="far fa-question-circle"></i></span></label>
            <div class="setting">
                <b-form-checkbox @change="settingsFromWeebly.settings.useTitle = !settingsFromWeebly.settings.useTitle" switch v-model="settingsFromWeebly.settings.useTitle" name="use-title-lighbox">
                    Use title
                </b-form-checkbox>
            </div>

            <!-- title background -->
            <div class="setting" v-if="settingsFromWeebly.settings.useTitle">
                <Mycolorpicker elementRef="titleBackground" theColorPicker="allpickers" colorPickerName="Title background:" />
            </div>

            <!-- title border -->
            <div class="setting" v-if="settingsFromWeebly.settings.useTitle">
                <Mycolorpicker elementRef="titleBorder" theColorPicker="allpickers" colorPickerName="Title border bottom color:" />
            </div>

        </div>

        <div class="settings-group-title">
            <h6>overlay</h6>
        </div>

        <div class="settings-group">
            <!-- overlay color -->
            <div class="setting">
                <Mycolorpicker elementRef="overlayColor" theColorPicker="allpickers" colorPickerName="Overlay color:" />
            </div>
        </div>

    </div>
</template>

<script>

import Mycolorpicker from './Mycolorpicker'
import Mycolorpickerchildblocks from './Mycolorpickerchildblocks'

export default {

    name: 'LightBoxSettings',

    data() {
        return {
            lightBoxName: null
        }
    },

    computed:{

        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        },

    },

    mounted() {
        // this.lightBoxName = this.$store.state.elementIdWeebly || 'temp_name'

        // console.log('lightBoxName: ',this.lightBoxName)
    },

    components: {
        // color picker
        Mycolorpicker,
        Mycolorpickerchildblocks
    },

    methods: {
    }
}
</script>

<style lang="less">
@import '../../../less/colors.less';

.trigger-link-to-copy {
    border: 1px solid @border_grey_dark;
    border-radius: .25rem;
    padding: 0.25rem 0.5rem;
    font-size: 13px;
}

</style>




// WEBPACK FOOTER //
// src/components/elements/elementSettings/LightBoxSettings.vue